import React from "react";
import ShareContainerButtons from "./SharedContainerButtons/SharedContainerButtons";

const Shared01Buttons = ({ options = {} }) => {
  const {
    main_objinfo,
    secundary_objinfo,
    btn_main_container_classes = "",
  } = options;

  // Normalizamos botones válidos
  const buttons = [main_objinfo, secundary_objinfo].filter(
    (btn) => btn && Object.keys(btn).length > 0
  );

  if (buttons.length === 0) return null;

  return (
    <div
      className={`container-btn t-flex t-flex-ac ${btn_main_container_classes}`}
    >
      {buttons.map((btnOptions, index) => (
        <ShareContainerButtons key={index} options={btnOptions} />
      ))}
    </div>
  );
};

export default Shared01Buttons;
